function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { createContact, getContact, updateContact } from "../store/actions/contacts";
import PageHeader from "../components/common/PageHeader";
import t from "../scripts/i18n";
import "../styling/pages/ContactForm.css";
import { Icon } from '@signicat/designi/components/icons';
import { isObject } from 'lodash';
var phoneUtil = PhoneNumberUtil.getInstance();

var ContactForm = function ContactForm(props) {
  var match = props.match;
  var id = match.params && match.params.id ? match.params.id : null;
  var dispatch = useDispatch();
  var history = useHistory();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      contact = _useState2[0],
      setContact = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ready = _useState4[0],
      setReady = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      mobile = _useState6[0],
      setMobile = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      formData = _useState8[0],
      setFormData = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      invalidFields = _useState10[0],
      setInvalidFields = _useState10[1];

  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });

  var formatMobile = function formatMobile(value) {
    if (value) {
      try {
        var mobileNumber = phoneUtil.parseAndKeepRawInput(value || '', 'NO');
        var isValid = phoneUtil.isValidNumber(mobileNumber);
        if (isValid) return {
          isValid: isValid,
          value: {
            prefix: "+".concat(mobileNumber.getCountryCode()),
            number: mobileNumber.getNationalNumber().toString()
          }
        };
      } catch (error) {
        return {
          isValid: false
        };
      }
    }

    return {
      isValid: false
    };
  };

  var phoneValidation = function phoneValidation(value) {
    return formatMobile(value).isValid;
  };

  var emailValidation = function emailValidation(email) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  };

  var handleInputChange = function handleInputChange(property) {
    return function (e) {
      var newData = _objectSpread({}, formData);

      var val = e.target.value;

      if (val === '') {
        delete newData[property];
      } else newData = _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, property, val));

      setFormData(newData);
    };
  };

  var validateForm = function validateForm() {
    var invalids = [];
    if (formData.mobileNumber && !phoneValidation(formData.mobileNumber)) invalids.push('mobileNumber');
    if (formData.email && !emailValidation(formData.email)) invalids.push('email');
    if (!formData.firstName) invalids.push('firstName');
    if (!formData.lastName) invalids.push('lastName');
    if (!formData.mobileNumber && !formData.email) invalids.push('emailOrMobile');
    setInvalidFields(invalids);
    return invalids.length;
  };

  var capitalize = function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
  };

  var submitContact = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var payload;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              if (!validateForm()) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              payload = contact ? _objectSpread({
                permissions: contact.permissions,
                portalUserId: contact.portalUserId,
                created: contact.created
              }, formData) : _objectSpread(_objectSpread({}, formData), {}, {
                permissions: {
                  groups: null,
                  users: [currentUserId]
                }
              });
              if (payload.mobileNumber) payload.mobileNumber = isObject(payload.mobileNumber) ? payload.mobileNumber : formatMobile(payload.mobileNumber).value;else delete payload.mobileNumber;
              payload.firstName = capitalize(payload.firstName);
              payload.lastName = capitalize(payload.lastName);
              _context.next = 10;
              return dispatch(id ? updateContact(payload) : createContact(payload));

            case 10:
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: 'Succesfully updated contact!',
                  type: 'success'
                }
              });
              history.push('/contacts');
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              dispatch({
                type: 'SET_NOTIFICATION',
                notification: {
                  text: t('notification_operation_failed'),
                  type: 'error'
                }
              });
              console.log(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 14]]);
    }));

    return function submitContact(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (invalidFields.length) validateForm();
  }, [formData]);
  useEffect(function () {
    if (!contact) return;

    var formattedContact = _objectSpread({}, contact);

    if (formattedContact.mobileNumber) formattedContact.mobileNumber = formattedContact.mobileNumber.prefix + formattedContact.mobileNumber.number;
    setFormData(formattedContact);
    setReady(true);
  }, [contact]);
  useEffect(function () {
    var getContactForForm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch(getContact(id));

              case 2:
                result = _context2.sent;
                setContact(result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getContactForForm() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (id) {
      getContactForForm();
    } else {
      setReady(true);
    }
  }, []);
  var fields = [{
    key: 'firstName',
    translationKey: 'contact_form_first_name',
    errorMessageKey: 'contact_form_firstname_required'
  }, {
    key: 'lastName',
    translationKey: 'contact_form_last_name',
    errorMessageKey: 'contact_form_lastname_required'
  }, {
    key: 'email',
    translationKey: 'contact_form_email',
    errorMessageKey: 'contact_form_invalid_email'
  }, {
    key: 'mobileNumber',
    translationKey: 'contact_form_phone',
    errorMessageKey: 'contact_form_invalid_phone'
  }, {
    key: 'companyName',
    translationKey: 'contact_form_company'
  }, {
    key: 'jobTitle',
    translationKey: 'contact_form_job_title'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-page  page-container"
  }, /*#__PURE__*/React.createElement(PageHeader, {
    title: id ? t('editing_contact_page_header') : t('adding_contact_page_header')
  }), invalidFields.includes('emailOrMobile') && /*#__PURE__*/React.createElement("div", {
    div: true,
    className: "general-validation-error"
  }, /*#__PURE__*/React.createElement("p", null, " ", t('contact_form_email_mobile_required'), " "), /*#__PURE__*/React.createElement(Icon, {
    name: "warning"
  })), /*#__PURE__*/React.createElement("div", {
    className: "contact-form ".concat(ready ? '' : 'display-none')
  }, fields.map(function (field) {
    return /*#__PURE__*/React.createElement("div", {
      key: field.key,
      className: "input-wrapper ".concat(invalidFields.includes(field.key) ? 'has-error' : '')
    }, /*#__PURE__*/React.createElement("span", null, " ", t(field.translationKey)), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: formData[field.key] || '',
      onChange: handleInputChange(field.key)
    }), invalidFields.includes(field.key) && /*#__PURE__*/React.createElement("p", {
      className: "error-message"
    }, t(field.errorMessageKey) || 'invalid'));
  })), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "secondary",
    onClick: function onClick() {
      return history.goBack();
    }
  }, t('contact_form_cancel')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: submitContact
  }, t('contact_form_save'))));
};

export default ContactForm;